import React, { memo, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { TOGGLE_LATEST_MSG, TOGGLE_PROJECT } from '../../store'
import styled from 'styled-components'
import { useTable } from 'react-table'
import { useDrag, useDrop } from 'react-dnd'
import update from 'immutability-helper'
import makeData from './makeData'
import { Badge, Form } from "react-bootstrap";
import { callAPI } from '../../helper/apiUtils'
import { KJUUP_COLORS, BASE_URL, getAvatarInitials } from '../../helper/constants'
import { useSelector } from 'react-redux'
import { ROOM_DND_TYPE, findRoomInLists, roomUnreadCount } from './roomDnd'
import { shouldShowDailyBriefingCounters } from '../../utils/dailyBriefingCounters'
import "./ProjectListComponentInternal.css";

// const Styles = styled.div`
//   padding: 1rem;

//   table {
//     border-spacing: 0;
//     border: 1px solid black;

//     tr {
//       :last-child {
//         td {
//           border-bottom: 0;
//         }
//       }
//     }

//     th,
//     td {
//       margin: 0;
//       padding: 0.5rem;
//       border-bottom: 1px solid black;
//       border-right: 1px solid black;

//       :last-child {
//         border-right: 0;
//       }
//     }
//   }
// `

const Table = ({ setRecords, data, chat_click, addUserToProject, handleShow, handleJoin, isLeave }) => {
  const [records, setRecordss] = React.useState([])
  useEffect(() => {
    setRecordss(data)
  }, [data])
  useEffect(() => {
    let data = [...records]
    let dt = [...data]
    for (let i = 0; i < data.length; i++) {
      dt[i].seqNumber = i + 1
    }
    _updateSq(data)
  }, [records])
  const _updateSq = async (dt) => {
    // const { data } = await callAPI(
    //   `/building/my/updateSequence`, null, "PUT", { data: dt }
    // );
  }
  const moveRow = (dragIndex, hoverIndex) => {
    const dragRecord = records[dragIndex]
    let x = update(records, {
      $splice: [
        [dragIndex, 1],
        [hoverIndex, 0, dragRecord],
      ],
    })
    setRecords(x)
    setRecordss(x)
    let data = [...x]
    let dt = [...data]
    for (let i = 0; i < data.length; i++) {
      dt[i].seqNumber = i + 1
    }
    let tmp = data.map((x) => {
      return {
        building: x.building,
        seqNumber: x.seqNumber,
        name: x.name,
      }
    })
    _updateSq(tmp)
  }

  return (
    <>
      {(records.length && records.length > 0) &&
        records.map(
          (row, index) =>
          (
            <Row
              key={row.id || index}
              index={index}
              row={row}
              moveRow={moveRow}
              chat_click={(x, proj) => chat_click(x, proj)}
              addUserToProject={(x) => addUserToProject(x)}
              handleShow={(x) => handleShow(x)}
              handleJoin={(x) => handleJoin(x)}
              isLeave={isLeave}
            />
          )
        )}
    </>
  )
}


const Row = ({ row, index, moveRow, addUserToProject, chat_click, handleJoin, handleShow, isLeave }) => {
  const dropRef = React.useRef(null)
  const dragRef = React.useRef(null)
  const dispatch = useDispatch()
  let project = { ...row }
  const [, drop] = useDrop({
    accept: ROOM_DND_TYPE,
    hover(item, monitor) {
      if (!dropRef.current) {
        return
      }
      const dragIndex = item.index
      const hoverIndex = index
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return
      }
      // Determine rectangle on screen
      const hoverBoundingRect = dropRef.current.getBoundingClientRect()
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
      // Determine mouse position
      const clientOffset = monitor.getClientOffset()
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return
      }
      // Time to actually perform the action
      moveRow(dragIndex, hoverIndex)
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex
    },
  })

  const [{ isDragging }, drag, preview] = useDrag({
    item: { type: ROOM_DND_TYPE, index, project: { ...project, isInternal: true } },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  })

  preview(drop(dropRef))
  drag(dragRef)
  const getProjectName = (name) => getAvatarInitials(name);

  let openProjects = useSelector(e => e.openProjects)
  const reduxProjects = useSelector(e => e.projects)
  const internalProjectsAll = useSelector(e => e.internalProjectsAll)
  const liveRoom = findRoomInLists(project.id, reduxProjects, internalProjectsAll) || project
  const user = useSelector((e) => e.user)
  const profile = useSelector((e) => e.profile)
  const subscription = useSelector((e) => e.subscription)
  const roomBadgeCount = roomUnreadCount(
    liveRoom,
    shouldShowDailyBriefingCounters(user, profile, subscription)
  )
  // Use string comparison for consistent ID matching
  let opened = openProjects?.findIndex(e => e.id && project.id && e.id.toString() === project.id.toString())

  return (
    // <></>
    <div
      key={project.id}
      className={`project_info pr-3 ${isDragging ? "project-list-component-internal__row--dragging " : ""}${opened !== -1 ? "active-project" : ""}`}
      ref={dropRef}
    >
      <div
        ref={(project.isJoin && !project.isDone) ? dragRef : null}
        onClick={(e) => {
          dispatch({ type: TOGGLE_PROJECT, payload: true });
          dispatch({ type: TOGGLE_LATEST_MSG, payload: false });
          chat_click(true, project)
        }}
        className="Project_name kj-flex-1"
      >
        <div className="position-relative">
          {project.image ? (
            <img
              src={BASE_URL + project.image}
              alt={project.name}
              className="project_icon project-list-component-internal__icon-img"
            />
          ) : (
            <div
              className={`project_icon project-list-component-internal__icon${(project.isJoin && !project.isDone) ? "" : " project-list-component-internal__icon--inactive"}`}
              style={{ "--project-theme-color": project.themeColor }}
            >
              {getProjectName(project.name)}
            </div>
          )}
          {Boolean(roomBadgeCount) && (
            <Badge
              className="project-notification pointer message-badge project-list-component-internal__badge"
              pill
            >
              <span className="project-list-component-internal__badge-count">
                {roomBadgeCount > 99 ? "99+" : roomBadgeCount}
              </span>
            </Badge>
          )}
        </div>
        <div
          className={`p_name project-list-component-internal__name${(project.isJoin && !project.isDone) ? "" : " project-list-component-internal__name--inactive"}`}
        >
          {project.name}
          {/* Room list marker (MyProject / roomOrder): internal in "All"; the pin sits on the right */}
          {project.listTag ? <span className="project-list-component__tag">{project.listTag}</span> : null}
          {/* <span>{project.city}</span> */}
        </div>
      </div>
      {!isLeave ?
        <div className="project_action">
          {(project.isJoin && !project.isDone) ? (
            // <a
            //   className="pointer"
            //   onClick={() => {
            //     addUserToProject(project);
            //   }}
            // >
            //   {project.isOpened ? (
            //     <img
            //       width={27}
            //       src={
            //         process.env.PUBLIC_URL +
            //         "/assets/img/add-project-deactivated.svg"
            //       }
            //     />
            //   ) : (
            //     <img
            //       width={27}
            //       src={
            //         process.env.PUBLIC_URL +
            //         "/assets/img/add-to-project.svg"
            //       }
            //     />
            //   )}
            // </a>
            project.listPinned ? (
              <span className="material-symbols-outlined project-list-component__pin" aria-hidden="true">keep</span>
            ) : null
          ) : (
            !project.isDone ?
              <a href="#"
                onClick={(e) => handleJoin(project)}
                className="d-flex align-items-center justify-content-center"
              >
                <span 
                  className="material-symbols-outlined project-list-component-internal__action-icon project-list-component-internal__action-icon--join"
                  onMouseEnter={(e) => e.target.style.color = 'var(--kjuup-internal)'}
                  onMouseLeave={(e) => e.target.style.color = '#737373'}
                >
                  add_circle
                </span>
              </a>
              :
              <div
                className="project-list-component-internal__done"
              >
                <span 
                  className="material-symbols-outlined project-list-component-internal__action-icon"
                >
                  check_circle
                </span>
              </div>
          )}
        </div>
        :
        <></>
      }
    </div>
  )
}

const ProjectListComponentInternal = ({ projects, chat_click, addUserToProject, handleShow, handleJoin, isLeave, cId }) => {
  const [OrigialRecords, setRecords] = React.useState([...projects])
  const [toSort, setToSort] = React.useState([])


  // useEffect(() => {
  //   setRecords([...projects])
  // }, [projects])
  const sortProjectList = (val) => {
    if (val) {
      if (val) {
        return val.sort((a, b) => {
          return a.seqNumber - b.seqNumber;
        });
      }
      else {
        return []
      }
    }
    else {
      return []
    }
  }

  useEffect(() => {
    setToSort([...projects])
    setRecords([...projects])
    // let projectListState = projects
    // let prj = projectListState
    // // for (let obj of prj) {
    // //   obj.seqNumber = 0
    // //   obj.building = obj.id
    // // }  
    // let isFirstList = true
    // for (let obj of prj) {
    //   obj.building = obj.id
    //   if (obj.seqNumber) {
    //     isFirstList = false
    //   }
    // }
    // if (isFirstList) {
    //   let joined = []
    //   let leaved = []
    //   for (let i = 0; i < prj.length; i++) {
    //     if (prj[i].isJoin) {
    //       joined.push(prj[i])
    //     }
    //     else {
    //       prj[i]['seqNumber'] = projectListState.length + 1
    //       leaved.push(prj[i])
    //     }
    //   }
    //   for (let i = 0; i < joined.length; i++) {
    //     joined[i]['seqNumber'] = i + 1
    //   }
    //   let final = [...joined]
    //   for (let obj of leaved) {
    //     final.push(obj)
    //   }
    //   setToSort([...final])
    //   setRecords([...final])
    // }
    // else {
    //   let joined = []
    //   let leaved = []
    //   for (let i = 0; i < prj.length; i++) {
    //     if (prj[i].isJoin) {
    //       joined.push(prj[i])
    //     }
    //     else
    //       leaved.push(prj[i])
    //   }
    //   for (let i = 0; i < leaved.length; i++) {
    //     leaved[i]['seqNumber'] = projectListState.length + 1
    //   }
    //   let final = [...joined]
    //   for (let obj of leaved) {
    //     final.push(obj)
    //   }
    //   setToSort([...final])
    //   setRecords([...final])
    // }
  }, [projects])

  return (
    toSort.length > 0 ?
      <Table
        data={toSort}
        setRecords={setRecords}
        chat_click={(x, proj) => chat_click(x, proj)}
        addUserToProject={(x) => addUserToProject(x)}
        handleShow={(x) => handleShow(x)}
        handleJoin={(x) => handleJoin(x, cId)}
        isLeave={isLeave}
      />
      :
      <div className="d-flex justify-content-center align-items-center h-100"></div>
  )
}

export default memo(ProjectListComponentInternal)
